import { render } from "./DigitalMarKetingPage.vue?vue&type=template&id=12efc04a"
import script from "./DigitalMarKetingPage.vue?vue&type=script&lang=js"
export * from "./DigitalMarKetingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__